const STORAGE_KEY = 'app_build_id'

// Injected by vite.config.js (`define`): a new value on every `vite build`, 'dev' on `vite serve`.
const CURRENT_BUILD_ID = __APP_BUILD_ID__

function clearCookies() {
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim()
    if (name) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    }
  })
}

/**
 * Clears cookies and localStorage the first time the user opens a newly deployed build.
 * Must run before anything reads the storage (router guards, store, API calls).
 */
export function resetStorageOnNewBuild() {
  try {
    if (localStorage.getItem(STORAGE_KEY) === CURRENT_BUILD_ID) return

    clearCookies()
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem(STORAGE_KEY, CURRENT_BUILD_ID)
  } catch {
    // storage unavailable (private mode / blocked) – nothing to reset
  }
}
